<template>
  <section class="home-notice">
    <div class="notice-inner g-container">
      <div class="notice-head">
        <span class="ico"></span>
        <strong>最新通知</strong>
      </div>
      <ul class="notice-list" v-if="noticeList.length">
        <li
          v-for="(item, idx) in noticeList"
          :key="item.id || idx"
          @click="toDetail(item.id)"
        >
          <span class="time">{{ formatDate(item.createTime) }}</span>
          <span class="title">{{ item.name }}</span>
        </li>
      </ul>
      <div class="notice-empty" v-else>暂无最新通知</div>
    </div>
  </section>
</template>

<script>
import { getInfo, getInfoByToken } from '@/lib/api/index'

export default {
  name: 'HomeNotice',
  data () { return { noticeList: [] } },
  created () {
    const fn = localStorage.getItem('token') ? getInfoByToken : getInfo
    fn().then((res) => {
      if (res.code === 200) {
        const list = (res.data && res.data[0]) || []
        this.noticeList = list.slice(0, 3)
      }
    })
  },
  methods: {
    formatDate (str) {
      if (!str) return ''
      return str.split(' ')[0]
    },
    toDetail (id) {
      this.$router.push({ path: '/detail', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.home-notice {
  background: #0F172A;
  color: #fff;
}

.notice-inner {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px 24px;
}

.notice-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  .ico {
    width: 24px; height: 24px;
    background: @primary;
    border-radius: 6px;
  }

  strong {
    font-weight: 600;
    font-size: 14px;
  }
}

.notice-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex: 1;
  gap: 32px;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    flex: 1;
    color: rgba(255, 255, 255, .7);
    transition: color @duration-fast @ease-out;

    &:hover { color: #fff; }

    .time {
      font-size: 12px;
      color: rgba(255, 255, 255, .5);
      flex-shrink: 0;
    }

    .title {
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.notice-empty {
  color: rgba(255, 255, 255, .5);
  font-size: 13px;
}
</style>
